import {
  REDIRECTION_URL,
  SPA_REDIRECTION_URL,
  QUICK_QUOTE_REDIRECTION,
} from "@/config/config";
import { HTTP_STATUS_CODES, INTENTS, MESSAGES } from "@/config/constants";
import {
  clearErrorData,
  getErrorDataSelector,
  removeReduxData
} from "@/features/error/errorSlice";
import { getIntent } from "@/features/proposal/proposalSlice";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Grid, Typography } from "@mui/material";
import isEmpty from "lodash/isEmpty";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { MUIButton } from "..";
import MUIModal from "../mui-modal";

const MuiErrorModal = () => {
  const error = useSelector(getErrorDataSelector);
  const dispatch = useDispatch();
  const router = useRouter();
  const intent = useSelector(getIntent);
  const redirectionURL = QUICK_QUOTE_REDIRECTION;
  const handleToggle = () => {
    if (error?.status === HTTP_STATUS_CODES.UNAUTHORIZED) {
      router.replace("/").then(() => {
        dispatch(removeReduxData());
      });
    }
    if (!isEmpty(error?.url)) {
      router.replace(error.url).then(() => {
        dispatch(clearErrorData());
      });
    } else {
      dispatch(clearErrorData());
    }
  };

  const handleMessage = (message) => {
    const parsedMessage =
      typeof message === "string"
        ? message
        : message?.data?.errorMessage || message?.message;

    if (error?.status === HTTP_STATUS_CODES.UNAUTHORIZED) {
      return MESSAGES.TOKEN_EXPIRE_MESSAGE;
    } else if (error?.status === HTTP_STATUS_CODES.TIMEOUT) {
      return MESSAGES.ERROR_TIMEOUT_MESSAGE;
    } else {
      return parsedMessage;
    }
  };
  return (
    <MUIModal
      open={error?.show}
      onClose={handleToggle}
      hasCloseButton={true}
      classToOveride={{ width: { xs: "90%", sm: "60%", md: "50%" }, p: 2 }}
    >
      <Grid container spacing={1} textAlign={"center"}>
        <Grid item xs={12}>
          {error?.isSuccess ? (
            <CheckCircleIcon
              fontSize="large"
              sx={{ color: "color.aigColor35" }}
            />
          ) : (
            <ErrorIcon fontSize="large" />
          )}
        </Grid>
        <Grid item xs={12}>
          <Typography>{handleMessage(error.msg) || "Error"}</Typography>
        </Grid>
        <Grid item xs={12}>
          <MUIButton variant={"aig-primary"} onClick={handleToggle}>
            {error?.buttonName || "Close"}
          </MUIButton>
        </Grid>
      </Grid>
    </MUIModal>
  );
};

export default MuiErrorModal;
